import React from "react";
import { Box, Container, Typography } from "@mui/material";

function OfficeMap() {
  return (
    <Box sx={{ py: 8, background: "#f5f5f5" }}>
      <Container>
        <Typography
          variant="h4"
          textAlign="center"
          fontWeight="bold"
          gutterBottom
        >
          Our Location
        </Typography>

        <Box
          sx={{
            width: "100%",
            height: "400px",
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 3,
          }}
        >
          <iframe
            title="Velvizhi Construction Location"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src="https://maps.google.com/maps?q=VELVIZHI%20construction%20PVT%20Ltd%2013.0803254,80.1746095&z=15&output=embed"
          ></iframe>
        </Box>
      </Container>
    </Box>
  );
}

export default OfficeMap;
